import { Grid, Paper, Box, Card, CardMedia, CardContent, Typography, CardActions, Button, Collapse, List, ListItem, ListItemText, IconButton } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import BuyNowPopup from './BuyNowPopup';
import { getAssistCourses, getCPDCourses } from '../../facades/CourseFacade';
import { UserContext } from '../../contexts/userContext';
import { registerUserForAssistCourse } from '../../facades/UserFacade';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { Stack } from '@mui/system';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

const images = [
    { 'color': '#F94144', 'color2': '#f98b41', 'code': 'aaa', 'name': 'Advanced Audit & Assurance', 'type': "elective" },
    { 'color': '#F3722C', 'color2': '#f3c52c', 'code': 'at', 'name': 'Australia Taxation', 'type': "elective" },
    { 'color': '#F8961E', 'color2': '#f8f11e', 'code': 'ata', 'name': 'Australia Taxation Advanced', 'type': "elective" },
    { 'color': '#F9844A', 'color2': '#f94a59', 'code': 'cbi', 'name': 'Contemporary Business Issues', 'type': "elective" },
    { 'color': '#F9C74F', 'color2': '#f94f65', 'code': 'df', 'name': 'Digital finance', 'type': "elective" },
    { 'color': '#90BE6D', 'color2': '#6dabbe', 'code': 'eg', 'name': 'Ethics & Governance', 'type': "core" },
    { 'color': '#43AA8B', 'color2': '#4373aa', 'code': 'fr', 'name': 'Financial Reporting', 'type': "core" },
    { 'color': '#4D908E', 'color2': '#4d5a90', 'code': 'frm', 'name': 'Financial Risk Management', 'type': "elective" },
    { 'color': '#577590', 'color2': '#8abae5', 'code': 'gsl', 'name': 'Global Strategy & Leadership', 'type': "core" },
    { 'color': '#277DA1', 'color2': '#9c27a1', 'code': 'sma', 'name': 'Strategic Management Accounting', 'type': "core" }
];

export default function FremiumCourses( {registrationCompleteCallback} ) {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [subjectName, setSubjectName] = React.useState('');
    const [courses, setCourses] = useState([]);
    const [cpd, setCpdCourses] = useState([]);
    const [coreOpen, setCoreOpen] = useState(false);
    const [electivesOpen, setElectivesOpen] = useState(false);
    const [cpdOpen, setCpdOpen] = useState(false);
    const userContext = useContext(UserContext);

    useEffect(() => {
        getAssistCourses(userContext.user)
            .then(res => res.json())
            .then((res) => {
                setCourses(res);
            });
        
        getCPDCourses(userContext.user)
        .then(res => res.json())
            .then((res) => {
                setCpdCourses(res);
            });
    }, []);

    const getCourseIdFromName = (name) => {
        if (courses.length === 0 || !name) return;
        const code = images[images.findIndex(c => c.name === name)].code;
        const course = courses.findIndex(c => c.title.toUpperCase().indexOf(code.toUpperCase()) !== -1);
        return courses[course]?.ID;
    };

    const registerUserAssistCourse = (name) => {
        const course_id = getCourseIdFromName(name);
        if (!course_id) return;
        registerUserForAssistCourse(userContext.user, course_id)
            .then(res => res.json())
            .then(res => {
                if (res['status'] === 'success') {
                   registrationCompleteCallback(course_id);
                }
            });
    };

    const registerUserCpdCourse = (id) => {
        registerUserForAssistCourse(userContext.user, id)
            .then(res => res.json())
            .then(res => {
                if (res['status'] === 'success') {
                    alert("You hve successfully registered for the course.");
                    registrationCompleteCallback(id)
                }
            });
    };

    const renderCpdCourses = () => {
    
        return cpd.map((course) => (
            <Grid item xs={12} sm={6} lg={3} key={course.id} sx={{ textAlign: 'center' }}>
                <Card sx={{
                    height: "100%",
                    width: '300px',
                    display: "flex",
                    borderRadius: '10px',
                    flexDirection: "column"
                }}>
                    <CardMedia
                        component="div"
                        sx={{
                            height: 150, alignContent: 'center', pl: 1, pr: 1,
                            backgroundImage: `radial-gradient(farthest-corner at 0px 0px, green 0%, lightgreen 100%)`
                        }}
                    >
                         <Stack direction="column">
                        <Typography sx={{ color: "#ffffff", fontWeight: "900", fontSize: 24 }}>{course.title}</Typography>
                       
                        </Stack>
                    </CardMedia>
                    <CardActions>
                    {course.completed_certificate ? <>
                            <Typography sx={{ color: "green", fontWeight: "900", fontSize: 18 }}>Completed!</Typography>
                            <EmojiEventsIcon sx={{ color: 'gold', fontSize: 40, alignSelf: 'center' }} />
                            
                            </>
                            :
                            <Button size="large" sx={{ bgcolor: '#F5EE00', color: 'black' }}
                            onClick={() => registerUserCpdCourse(course.id)}>Register Now!</Button>
                        }
                    </CardActions>
                </Card>
            </Grid>
        ));
            
    }

    const renderCourses = (type) => {
        return images.filter((image) => image.type === type).map((image) => (
            <Grid item xs={12} sm={6} lg={3} key={image.code} sx={{ textAlign: 'center' }}>
                <Card sx={{
                    height: "100%",
                    width: '300px',
                    display: "flex",
                    borderRadius: '10px',
                    flexDirection: "column"
                }}>
                    <CardMedia
                        component="div"
                        sx={{
                            height: 150, alignContent: 'center', pl: 1, pr: 1,
                            backgroundImage: `radial-gradient(farthest-corner at 0px 0px, ${image.color2} 0%, ${image.color} 100%)`
                        }}
                    >
                        <Typography sx={{ color: "#ffffff", fontWeight: "900", fontSize: 32 }}>{image.name}</Typography>
                    </CardMedia>
                    <CardActions>
                        <Button size="large" sx={{ bgcolor: '#F5EE00', color: 'black' }}
                            onClick={() => registerUserAssistCourse(image.name)}>Register Now!</Button>
                        <Button size="small" sx={{ color: 'grey' }} onClick={() => { setOpenDialog(true); setSubjectName(image.name); }}>Learn More</Button>
                    </CardActions>
                </Card>
            </Grid>
        ));
    };

    return (
        <React.Fragment>
            <Paper sx={{
        color: "white",
        borderRadius: "15px",
        padding: 1,
       // boxShadow: "0 0 10px 2px #8bc34a", // Glowing green border
        //border: "2px solid #8bc34a", // Solid green border
    }}>
            <BuyNowPopup openDialog={openDialog} handleClose={() => { setOpenDialog(false); }} subjectName={subjectName} subjectId={getCourseIdFromName(subjectName)} />
            <List>
               
                {/* CPD */}
                <ListItem onClick={() => setCpdOpen(!cpdOpen)} style={{ cursor: "pointer" }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <ListItemText primary="CPD - Ethics" 
                         primaryTypographyProps={{
                            fontSize: "1.25rem", 
                            fontWeight: "bold" 
                        }}/>
                        <Typography sx={{color:"blue"}}>NEW FOR 2026</Typography>
                        <NewReleasesIcon sx={{ color: 'blue', marginLeft: '5px' }} />
                    </Stack>
                    <IconButton sx={{ marginLeft: "auto" }}>
                        <ExpandMoreIcon />
                    </IconButton>
                </ListItem>
                <Collapse in={cpdOpen} timeout="auto" unmountOnExit >
                    <Typography variant="button" sx={{color : "blue", p:1, mb:1}}>These courses are eligible for the required CPA Ethics professional development hours.</Typography>
                    <Grid container spacing={2}>
                    {renderCpdCourses()}
                    </Grid>
                </Collapse>
            </List>
            </Paper>
        </React.Fragment>
    );
}

/**** CORE AND ELECTIVES DROPDOWNS ****
 Core Subjects 
 <ListItem onClick={() => setCoreOpen(!coreOpen)} style={{ cursor: "pointer" }}>
 <ListItemText primary="Core Subjects - Assist Courses" 
     primaryTypographyProps={{
         fontSize: "1.25rem", 
         fontWeight: "bold" 
     }}/>
 <IconButton>
     <ExpandMoreIcon />
 </IconButton>
</ListItem>
<Collapse in={coreOpen} timeout="auto" unmountOnExit>
 <Grid container spacing={2}>
     {renderCourses("core")}
 </Grid>
</Collapse>


<ListItem onClick={() => setElectivesOpen(!electivesOpen)} style={{ cursor: "pointer" }}>
 <ListItemText primary="Electives - Assist Courses" 
      primaryTypographyProps={{
         fontSize: "1.25rem", 
         fontWeight: "bold" 
     }}/>
 <IconButton>
     <ExpandMoreIcon />
 </IconButton>
</ListItem>
<Collapse in={electivesOpen} timeout="auto" unmountOnExit>
 <Grid container spacing={2}>
     {renderCourses("elective")}
 </Grid>
</Collapse>
*/